import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import type { ESizeFrom } from './config';
import { IMultiDiffValue } from '../../../constants';

export interface IPositionFeature extends IBaseDrawerFeature {
    /**
     * 水平位置
     */
    left: number;
    /**
     * 垂直位置
     */
    top: number;
    /**
     * 水平位置从
     */
    horizontalFrom: string;
    /**
     * 垂直位置从
     */
    verticalFrom: string;
    /**
     * 水平位置从 的变化
     */
    handleHorizontalFromChange(value: ESizeFrom): void;
    /**
     * 垂直位置从 的变化
     */
    handleVerticalFromChange(value: ESizeFrom): void;
    /**
     * 水平位置变化
     */
    handleLeftChange(value: number, from?: NumberInputFrom): void;
    /**
     * 垂直位置变化
     */
    handleTopChange(value: number, from?: NumberInputFrom): void;
}

export const IPositionFeature = Symbol.for('feature:position');

DynamicLoaderRegistry.merge(IPositionFeature, {
    useFactory: async () => {
        const { PositionFeature } = await import('./position-feature');
        return PositionFeature;
    },
    on: loadTask,
});
